import { render, staticRenderFns } from "./GameImport.vue?vue&type=template&id=20b47bae&scoped=true&"
import script from "./GameImport.vue?vue&type=script&lang=js&"
export * from "./GameImport.vue?vue&type=script&lang=js&"
import style0 from "./GameImport.vue?vue&type=style&index=0&id=20b47bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b47bae",
  null
  
)

export default component.exports